export default "__VITE_ASSET__d25fd360__"